module.exports = __webpack_public_path__ + "static/media/gb.8ba4a7c9.png";